<script setup lang="ts">
import {
  HeaderNavigation,
  HeaderCitySelector,
  HeaderUser,
  HeaderLangSelector,
} from "@/modules/app-header";
import { IconCircleInfoFill } from "@packages/icon-library";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const scrollPosition = ref(0);
const scrolled = ref(true);

const scrollHandler = () => {
  if (scrollPosition.value < window.scrollY) {
    scrolled.value = true;
  }

  if (scrollPosition.value > window.scrollY) {
    scrolled.value = false;
  }

  scrollPosition.value = window.scrollY;
};

onMounted(() => {
  window.addEventListener("scroll", scrollHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", scrollHandler);
});
</script>

<template>
  <header v-if="!scrolled || scrollPosition < 50" class="app-header">
    <div class="app-header__top">
      <div class="container">
        <HeaderCitySelector />
        <HeaderLangSelector />
        <a
          href="https://support.rc.today/sign-in?source=cs"
          target="_blank"
          class="header-item"
        >
          <IconCircleInfoFill /> {{ t("nav.support") }}
        </a>
      </div>
    </div>
    <div class="app-header__bottom">
      <div class="container">
        <RouterLink :to="{ name: 'HomeView' }">
          <img src="@/assets/logo.svg" alt="logotype" />
        </RouterLink>
        <HeaderNavigation />
        <HeaderUser />
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;

  &__top {
    background-color: var(--color-semantic-background-normal-secondary);
    position: relative;
    height: 44px;

    > .container {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: calc($base-space * 3);

      > a {
        margin: 0 0 0 auto;
      }
    }
  }

  &__bottom {
    border-top: 1px solid var(--color-semantic-border-normal-soft);
    border-bottom: 1px solid var(--color-semantic-border-normal-soft);
    background-color: var(--color-semantic-background-normal-bg-primary);
    height: 68px;

    > .container {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: calc($base-space * 6);

      > a {
        display: flex;
        align-items: center;
        justify-content: center;

        > img {
          width: 115px;
        }
      }
    }
  }
}

.services {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: $base-space * 2;
}

.links {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: $base-space * 3;
}

.scrolled {
  position: fixed;
  top: 0;
  left: 0;
}
</style>
